
cc.Class({
    extends: cc.Component,

    properties: {
        useThemeColor: false,
        hoverColor: cc.Color,
        target: cc.Node
    },

    onLoad () {
        this.node.on(cc.Node.EventType.MOUSE_ENTER, this._onMouseDown.bind(this), this);
        this.node.on(cc.Node.EventType.MOUSE_MOVE, this._onMouseDown.bind(this), this);
        this.node.on(cc.Node.EventType.MOUSE_LEAVE, this._onMouseUp.bind(this), this);
        this.addNestedChildListeners(this.node);

        if (!this.target) {
            this.target = this.node;
        }
        if (this.target.getComponent('ThemeItem')) {
            const themeController = cc.find('PSUIInitializer/PSUI/ThemeController').getComponent('ThemeController');

            this.origin = { color: themeController.themeColor };
        } else {
            this.origin = { color: this.target.color };
            this.origin.color.a = this.target.opacity;
        }
        this.isMouseDown = false;

        if (this.useThemeColor) {
            const themeController = cc.find('PSUIInitializer/PSUI/ThemeController').getComponent('ThemeController');

            this.hoverColor = themeController.themeColor;
        }
    },

    addNestedChildListeners (node) {
        node.children.forEach((child) => {
            if (child.getComponent(cc.Button)) {
                child.on(cc.Node.EventType.MOUSE_LEAVE, this._onMouseUp.bind(this), this);
            }
            this.addNestedChildListeners(child);
        });
    },

    onDisable () {
        if (this.origin) {
            this._onMouseUp();
        }
    },

    _onMouseDown () {
        if (this.button && !this.button.interactable) {
            return;
        }

        if (!this.isMouseDown) {
            this._applyColor(this.hoverColor);
        }

        this.isMouseDown = true;
    },

    _applyColor (color) {
        this.target.color = new cc.Color(color.r, color.g, color.b);
        this.target.opacity = color.a;
    },

    _onMouseUp () {
        this._applyColor(this.origin.color);
        this.isMouseDown = false;
    }
});
